import React from 'react'

export interface LayoutContextProps {
  sidebarRef: React.RefObject<HTMLDivElement | null>
}

export const LayoutContext = React.createContext<LayoutContextProps>({
  sidebarRef: { current: null },
})
